import React from "react";
import { Card, Container, Button } from "react-bootstrap";
import {
  companionCard, cardBody, companionsBtn, cardLink,
  cardTitle, companions, companion,
} from "./style.mod.scss";
import getImagePath from "helpers/get-image-path";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Mousewheel } from "swiper";
import Link from "components/link";

const CollectionList = ({ data }) => {
  const { btnText, btnUrl, collectionProduct } = data;

  const settings = {
    slidesPerView: 1.5,
    spaceBetween: 20,
    loop: false,
    autoHeight: true,
    modules: [Pagination, Mousewheel],
    pagination: { clickable: true },
    speed: 700,
    parallax: true,
    preventClicks: true,
    preventClicksPropagation: false,
    simulateTouch: false,
    mousewheel: {
      enabled: true,
      forceToAxis: true,
    },
    breakpoints: {
      567: {
        slidesPerView: 3,
        spaceBetween: 20,

      },
      1200: {
        spaceBetween: 25,
        slidesPerView: 4,
      }
    }
  };

  return (
    <div className={companions}>
      <Container>
        <Swiper {...settings} >
          {
            collectionProduct.map((c) => (
              <SwiperSlide key={c._key}>
                <div className={companion} >
                  <Link to={c.prodUrl} className={cardLink}>
                    <Card className={companionCard} >
                      <Card.Img variant="top" src={getImagePath(c?.prodImage)} alt={c?.prodImage?.alt} />
                      <Card.Body className={cardBody}>
                        <Card.Title className={cardTitle}>{c.prodName}</Card.Title>
                      </Card.Body>
                    </Card>
                  </Link>
                </div>
              </SwiperSlide>
            ))
          }
        </Swiper>
        <Button href={btnUrl} className={companionsBtn}>{btnText}</Button>
      </Container>
    </div>
  );
};

export default CollectionList;
